const blastEndpoints = {
  localBlastUrl: "http://localhost:4200",
  productionBlastUrl: "https://www.pppforgiveness.net",
  phasesDocuments: "/phases-documents",
  ticklersExceptions: "/ticklers-exceptions",
  localOnlyOfficeUrl: "http://localhost:8000"
};
export default blastEndpoints;
